import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
var AES = require("crypto-js/aes");
var SHA256 = require("crypto-js/sha256");
var CryptoJS = require("crypto-js");

const API_URL = 'partner';
//const API_URL = 'http://localhost:8080';
var funcToken1 = (to, from, next) => {
  if (to.matched.some(record => (record.meta.adminOnly))) {
  } else {
    if (sessionStorage.getItem('token')) {
      next({
        path: '/dashboard'
      })
    } else {
      next();
    }
  }
}
var funcToken2 = (to, from, next) => {
  if (to.matched.some(record => (record.meta.adminOnly))) {
    if (!sessionStorage.getItem('token')) {
      next({
        path: '/home'
      })
    } else {
      next();
    }
  } else {
    next();
  }
}
const BASE_HEADERS = "";
var getHeaders = (multipart = false) =>{
  let defaultHeaders = BASE_HEADERS
  if (multipart) {
      defaultHeaders = {}
  }
  if (sessionStorage.getItem('token')) {
      defaultHeaders = {
          'Authorization': "Bearer " + sessionStorage.getItem('token'),
          ...defaultHeaders
      }
  }
  return defaultHeaders
}
var funcToken3 = (to, from, next) => {
  if(to.name=="CustomerRegistrationdummy") { 
    axios.get(`${API_URL}/api/isCustomerAdmin?encCompanyCode=${sessionStorage.getItem('routeCompanyCode')}&eipUserId=${sessionStorage.getItem('routeEipUserId')}`, {
      headers: getHeaders(),
      withCredentials: false
  }, { timeout: 180000 }).then(res => {
      if (res.data.response == false) {
        window.alert('Access Denied!. You are not allowed to access the requested page. please contact support')
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL)
        return false
      } else {        
  if (to.matched.some(record => (record.meta.adminOnly))) {
    if (!sessionStorage.getItem('token')) {
      next(
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL)
      )
    } else {
      next();
    }
  } else {
    next();
  }
      }
    })
    .catch(err => {
      window.alert('Error navigating to requested page')
      return false
    });
  } else if(to.name=="GrievanceDashboard") {
    axios.get(`${API_URL}/api/partner-details/allowviewgrievancedashboard?eipuserid=${sessionStorage.getItem('routeUserId')}`, {
      headers: getHeaders(),
      withCredentials: false
  }, { timeout: 180000 }).then(res => {
      if (res.data.status != "SUCCESS") {
        window.alert('Access Denied!. You are not allowed to access the requested page. please contact support')
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL)
        return false
      } else {        
  if (to.matched.some(record => (record.meta.adminOnly))) {
    if (!sessionStorage.getItem('token')) {
      next(
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL)
      )
    } else {
      next();
    }
  } else {
    next();
  }
      }
    })
    .catch(err => {
      window.alert('Error navigating to requested page')
      return false
    });
  } else {
  if (to.matched.some(record => (record.meta.adminOnly))) {
    if (!sessionStorage.getItem('token')) {
      next(
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL)
      )
    } else {
      next();
    }
  } else {
    next();
  }
}
}

Vue.use(Router)
export default new Router({
  mode: "history",
  base: "/PartnerMgmtApp/",
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/home',
      meta: {
        adminOnly: false,
      },
      beforeEnter: (to, from, next) => funcToken1(to, from, next)
    },
    {
      path: '/designPage',
      name: 'Design Page',
      component: () => import("@/pages/DummyDesign.vue"),
      meta: {
        adminOnly: false,
      },
    },
    {
      path: '/home',
      name: 'home',
      component: () => import("@/pages/HomePage.vue"),
      meta: {
        layout: "sidebar",
        adminOnly: false,
      },
      beforeEnter: (to, from, next) => funcToken1(to, from, next)
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import("@/pages/LoginPage.vue"),
      meta: {
        layout: "no-sidebar",
        adminOnly: false,
      },
      beforeEnter: (to, from, next) => funcToken1(to, from, next)
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: () => import("@/pages/ResetPassword.vue"),
      meta: {
        layout: "sidebar",
        adminOnly: false
      },
      beforeEnter: (to, from, next) => funcToken1(to, from, next)
    },
    /************************************** PARTNER   ONBOARDING *********************************  */
    {
      path: '/registration',
      name: 'RegisterPage',
      component: () => import("@/pages/RegisterPage.vue"),
      meta: {
        layout: "sidebar",
        adminOnly: false
      },
      beforeEnter: (to, from, next) => funcToken1(to, from, next)
    },
    {
      path: '/dashboard',
      name: 'DashboardPage',
      component: () => import("@/pages/DashBoard.vue"),
      meta: {
        layout: "dashboard",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/changepassword',
      name: 'ChangePasswordPage',
      component: () => import("@/pages/changePassword.vue"),
      meta: {
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/onboardingDetails',
      name: 'OnboardingDetails',
      component: () => import("@/pages/OnboardingDetails.vue"),
      meta: {
        layout: "dashboard",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('userToken')) {
          var bytes = CryptoJS.AES.decrypt(sessionStorage.getItem('userToken'), "partnerSecret").toString(CryptoJS.enc.Latin1)
        }
        if (to.matched.some(record => (record.meta.adminOnly))) {
          if (bytes == 'Approved') {
            next({
              path: '/partnerdashboard'
            })
            return;
          } else {
            next();
          }
          if ((!sessionStorage.getItem('token')) || bytes == 'View') {
            next({
              path: '/home'
            })
          } else {
            next();
          }
        } else {
          next();
        }
      }
    },
    {
      path: '/onboardingDetailPreview',
      name: 'OnboardingPreview',
      component: () => import("@/pages/OnboardingPreview.vue"),
      meta: {
        layout: "dashboard",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('userToken')) {
          var bytes = CryptoJS.AES.decrypt(sessionStorage.getItem('userToken'), "partnerSecret").toString(CryptoJS.enc.Latin1)
        }
        if (to.matched.some(record => (record.meta.adminOnly))) {
          if (bytes == 'Approved') {
            next({
              path: '/partnerdashboard'
            })
            return;
          } else {
            next();
          }
          if (!sessionStorage.getItem('token') || bytes == 'Edit') {
            next({
              path: '/home'
            })
          } else {
            next();
          }
        } else {
          next();
        }
      }
    },
    {
      path: '/email-verification',
      name: 'EmailVerification',
      component: () => import("@/pages/EmailVerificationPage.vue"),
      meta: {
        layout: "no-sidebar"
      }
    },
    /************************************** PARTNER  AFTER ONBOARD *********************************  */
    {
      path: '/partnerStatus',
      name: 'PartnerStatus',
      component: () => import("@/pages/partnerStatus.vue"),
      meta: {
        layout: "partner-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnerdashboard',
      name: 'dashboard',
      component: () => import("@/pages/partner/partnerDashboard.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnerprofile',
      name: 'partnerProfile',
      component: () => import("@/pages/partner/partnerProfile.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/addcompany',
      name: 'addNewCompany',
      component: () => import("@/pages/partner/addNewCompany.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnerauctions',
      name: 'PartnerAuction',
      component: () => import("@/pages/partner/partnerAuction.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnersummary',
      name: 'PartnerSummary',
      component: () => import("@/pages/partner/partnerSummary.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnerinvoice',
      name: 'PartnerInvoice',
      component: () => import("@/pages/partner/partnerInvoice.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnerreminder',
      name: 'PartnerReminer',
      component: () => import("@/pages/partner/partnerReminder.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/partnerfeedback',
      name: 'PartnerFeedback',
      component: () => import("@/pages/partner/partnerFeedback.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/claimrequest',
      name: 'ClaimRequest',
      component: () => import("@/pages/partner/claimRequest.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/branchdetails',
      name: 'Branch Details',
      component: () => import("@/pages/partner/partnerBranchDetails.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    {
      path: '/testimonials',
      name: 'Testimonials',
      component: () => import("@/pages/partner/testimonials.vue"),
      meta: {
        layout: "partner-sidebar",
        adminOnly: true
      },
      beforeEnter: (to, from, next) => funcToken2(to, from, next)
    },
    /********************************************************* SUMMARY PAGE*****************************************************************************  */

    {
      path: '/summarypage',
      name: 'Summary',
      component: () => import("@/pages/SummaryPage.vue"),
      meta: {
        adminOnly: true,
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/segregator',
      name: 'Segregator',
      component: () => import("@/pages/Segregator.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/Categorizer',
      name: 'Categorizer',
      component: () => import("@/pages/Categorizer.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/Workbench',
      name: 'Workbench',
      component: () => import("@/pages/Workbench.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/partnerforensics',
      name: 'partnerforensics',
      component: () => import("@/pages/PartnerForensics.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/ForensicsDashboard',
      name: 'ForensicsDashboard',
      component: () => import("@/pages/ForensicsDashboard.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/Reports',
      name: 'Reports',
      component: () => import("@/pages/Reports.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/PartnerQueries',
      name: 'PartnerQueries',
      component: () => import("@/pages/PartnerQueries.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/GrievanceDashboard',
      name: 'GrievanceDashboard',
      component: () => import("@/pages/GrievanceDashboard.vue"),
      meta: {
        layout: "no-sidebar" 
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/GrievanceInternational',
      name: 'GrievanceInternational',
      component: () => import("@/pages/GrievanceInternational.vue"),
      meta: {
        layout: "no-sidebar",
        adminOnly: true
      }
    },
    {
      path: '/CustomerRegistration',
      name: 'CustomerRegistration',
      props: (route) => ({ uid: route.query.Uid, auditNo: route.query.AuditNo, documentNo: route.query.DocumentNo, RefId: route.query.RefId, companyCode: route.query.CompanyCode, source: route.query.Source }),
      component: () => import("@/pages/CustomerRegistration.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/VendorDetails',
      name: 'VendorDetails',
      component: () => import("@/pages/VendorMasterView.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next),  props: true
    },
    {
      path: '/partnerApprovalPage',
      name: 'PartnerApproval',
      component: () => import("@/pages/partnerApproval.vue"),
      meta: {
        layout: "no-sidebar"
      },
      beforeEnter: (to, from, next) => funcToken3(to, from, next)
    },
    {
      path: '/getsession',
      name: 'session',
      component: () => import("@/pages/redirectionPage.vue"),
      props: (route) => ({ uid: route.query.Uid, auditNo: route.query.AuditNo, documentNo: route.query.DocumentNo, RefId: route.query.RefId, companyCode: route.query.CompanyCode, source: route.query.Source, jobCode: route.query.JobCode }),
      meta: {
        layout: "no-sidebar"
      }
    }
  ]
});
